import React from 'react'
import MasterLayout from '../../../masterLayout/MasterLayout'
import Breadcrumb from '../../../components/Breadcrumb'
import ReSchedulePolicy from './ReSchedulePolicy';

const ReSchedulePolicyLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="ReSchedule Policy" />
      <ReSchedulePolicy />
    </MasterLayout>
  );
}

export default ReSchedulePolicyLayout